/**
 * Parse API DateTime / DateTimeOffset values for countdown targets.
 *
 * CAPMAS APIs often return Egypt wall-clock time with a fixed +02:00 offset
 * even when Egypt is on UTC+3 (summer). Native Date then treats expiry as
 * one hour later than intended. For offset-bearing strings we use the
 * date/time portion as local wall-clock time. Pure UTC (Z) strings from
 * Date#toISOString are parsed normally.
 */
export function parseApiDateTime(value) {
  if (value == null || value === "") {
    return NaN;
  }

  if (typeof value === "number") {
    return Number.isFinite(value) ? value : NaN;
  }

  const str = String(value).trim();

  if (/Z$/i.test(str)) {
    const utcTime = new Date(str).getTime();
    return Number.isNaN(utcTime) ? NaN : utcTime;
  }

  const withOffset = str.match(
    /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})(\.\d+)?([+-]\d{2}:\d{2})$/
  );

  if (withOffset) {
    const fraction = withOffset[2] ? withOffset[2].slice(0, 4) : "";
    const localWallClock = `${withOffset[1]}${fraction}`;
    const localTime = new Date(localWallClock).getTime();
    return Number.isNaN(localTime) ? NaN : localTime;
  }

  const fallback = new Date(str).getTime();
  return Number.isNaN(fallback) ? NaN : fallback;
}

export function toCountDownIso(value) {
  const time = parseApiDateTime(value);
  if (Number.isNaN(time)) {
    return null;
  }
  return new Date(time).toISOString();
}
